import React from 'react';
import { FaGraduationCap } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import ContentLibrary from '../components/ContentLibrary';

const PaisoKiPathshala = () => {
  const { isFreePlan } = useAuth();

  return (
    <div className="space-y-6" data-testid="paiso-ki-pathshala-page">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 bg-[#FFD700]/20 rounded-lg flex items-center justify-center">
          <FaGraduationCap className="text-[#FFD700] text-2xl" />
        </div>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-white">Paiso Ki Pathshala</h1>
          <p className="text-gray-400 text-sm">Learn Personal Finance &amp; Money Management</p>
        </div>
      </div>

      <ContentLibrary title="Learning Resources" isFreePlan={isFreePlan} />
    </div>
  );
};

export default PaisoKiPathshala;
